/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Eyebrow_ExamplesInputs */

const en_directory_ai_tools_eyebrow_examples = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_ExamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Examples`)
};

const zh_directory_ai_tools_eyebrow_examples = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_ExamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`示例`)
};

/**
* | output |
* | --- |
* | "Examples" |
*
* @param {Directory_Ai_Tools_Eyebrow_ExamplesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_eyebrow_examples = /** @type {((inputs?: Directory_Ai_Tools_Eyebrow_ExamplesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Eyebrow_ExamplesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_eyebrow_examples(inputs)
	return zh_directory_ai_tools_eyebrow_examples(inputs)
});
export { directory_ai_tools_eyebrow_examples as "directory.ai_tools.eyebrow.examples" }